import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import Pagination from "components/Common/newPagination";
import ClassListUpsert from "./upsert/classListUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function ClassListPage(param: any) {

  let [searchReleaseIsrc, setSearchReleaseIsrc] = useState<string>("");
  let [searchText, setSearchText] = useState<string>("");
  let [ClassListCount, SetClassListCount] = useState(0);
  let [editingOn, setEditingOn] = useState<boolean>(false);
  let [classListCount, SetclassListCount] = useState(0);
  let [ClassListing, SetClassListing] = useState<any>([]);
  let [searchZone, setSearchZone] = useState<string>("");
  let [searchFormatCode, setSearchFormatCode] = useState<string>("");


  var payload = { pageNumber: 1, pageSize: 10, format: searchFormatCode, territoryCode: searchZone }

  const classListSelect = () => {
    ClassListing = [];
    SetClassListing(ClassListing)

    classListCount = 0
    SetclassListCount(classListCount)

    systemListingService.MechanicalRateListing(payload).then((res: any) => {
      ClassListing = res;
      SetClassListing(ClassListing)
      classListCount = res[0].totalRows
      SetclassListCount(classListCount)
    })
  }

  const onPageChange = (e: any) => {
    console.log(e)
    payload.pageNumber = e.pageNumber;
    payload.pageSize = e.pageSize;
    classListSelect();
  }

  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    console.log(deleteData)
    if (e == 1) {
      systemFormatsList.deleteclasslist(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Class list delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const export_classList = () => {
    systemListingService.classlistExport({ ReleaseISRC: "", SearchText: "", export: 1 })
  }

  return (
    <>
      <div className="content-card ws-12">

        <div className="ws-12">
          <div className="card-title">MPM / Class List</div>

          <div className="ws-12 mb">
            <span className="pt mt pull-left">{ClassListCount} record(s) found  </span>
            <button className="icon-btn info pull-right" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}> {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}  </button>
          </div>
        </div>

        <div className="ws-12 ptl mt">

          <div className="ws-4">
            <div className="ws-12 text-bold pb">Search Text</div>
            <input className="ws-10" placeholder="Search by code, format" value={searchText} onChange={(e) => { setSearchText(e.target.value); }} />
          </div>

          <div className="ws-4">
            <label className="ws-12 text-bold pb">ReleaseISRC</label>
            <input className="ws-10" placeholder="Enter releaseISRC" value={searchReleaseIsrc} onChange={(e) => setSearchReleaseIsrc(e.target.value)} />
          </div>

          <div className="ws-4 pull-right heigh35">
            <button className="icon-btn primary fill height35 pull-right" onClick={() => openAddDrawer({})}>Add Class List </button>
            <button className="icon-btn primary height35 pull-right" onClick={classListSelect}>  Search  </button>
            <button className="icon-btn primary height35 pull-right" onClick={export_classList}> <i className="icon-download1"></i></button>
          </div>

        </div>

        <div className="ws-12 ptl mt">
          {classListCount > 0 && <table>
            <thead>
              <tr>
                <th>ReleaseISRC</th>
                <th>Class List</th>
                <th>ReleaseAlt1</th>
                <th>ReleaseAlt2</th>
                <th>ReleaseAlt3</th>
                <th>ReleaseAlt4</th>
                <th>ReleaseAlt5</th>
                <th>ReleaseAlt6</th>
              </tr>
            </thead>
            <tbody>
              {ClassListing.map((row: any) => (
                <tr key={row.id}>
                  <td>{row.releaseIsrc}</td>
                  <td>{row.classList}</td>
                  <td>{row.releaseAlt1}</td>
                  <td>{row.releaseAlt2}</td>
                  <td>{row.releaseAlt3}</td>
                  <td>{row.releaseAlt4}</td>
                  <td>{row.releaseAlt5}</td>
                  <td>{row.releaseAlt6}</td>
                </tr>
              ))}
            </tbody>
          </table>}

          {classListCount === 0 && <div className="ws-12">
            <div className="alert alert-info ws-12 box" >No records to display</div>
          </div>}

          {(classListCount > 0 && classListCount > 10) && <Pagination totalRow={classListCount} onPageChange={onPageChange} />}
        </div>

      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <ClassListUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} editDataDawer={editDataDawer} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete class with releaseISRC: " + deleteData?.releaseISRC} onChange={deleteConfirmation} />
          }
        })()
      }
    </>
  );
};